import React from 'react';
import Section from '../../../elements/Section';
import Title from '../../../elements/Title';
import Content from '../../../elements/Content';
import Link from '../../../components/Link';

export default function Introduction() {
  return (
    <Section>
      <Title>Introduction</Title>
      <Content>
        Condor Technologies NV is a Belgian company located in Ghent
        specialising in the development, manufacturing, and sales of dental
        intraoral scanners, designed to make life-like coloured scans of teeth.
        This enables dentists all over the world to provide better care, from
        diagnosis to restoration. For more information about the product please
        surf to our website:{' '}
        <Link href="https://www.condorflash.com/">
          https://www.condorflash.com/
        </Link>
        .
      </Content>
    </Section>
  );
}
